// @flow

export default (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(new Blob([blob]));

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${filename}.pdf`);
  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(url);
};
